import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DocTypeSelector from 'components/Mobile/DocTypeSelector'
import InputTitle from 'components/Mobile/InputTitle'
import PhotoInput from 'components/Mobile/PhotoInput'
import Selector from 'components/Mobile/Selector'
import UploadItemList from 'components/Mobile/UploadItemList'
import { MOBILE_MAX_UPLOAD_FILES } from 'config'

import type { ProvidedProps } from 'hooks/useDocUpload'

const UploadFields = (props: Omit<ProvidedProps, 'onSendMobile' | 'reset'>) => {
  const {
    // uploading,

    docTypeOptions,
    docType,
    onDocTypeChange,
    ocrBuilderConfigID,
    onOcrBuilderConfigIDChange,

    group,
    groupOptions,
    onGroupChange,
    groupDisabled,

    files,
    onAddFiles,
    onDeleteFile,
  } = props

  const groupSelectOptions = groupOptions.map((x) => ({ label: x, value: x }))

  return (
    <Box overflow="auto" paddingX={2} flexGrow={1} flexShrink={1}>
      <Box paddingTop={1}>
        <Typography variant="h6" component="h2">
          画像を選択してOCRアップロード
        </Typography>
        <Typography variant="caption">
          スマートフォンで撮影した画像をOCR処理して、OCR Readerへアップロードすることができます。
        </Typography>
      </Box>
      <Box paddingTop={1}>
        <InputTitle label="画像を追加" />
        <PhotoInput limitReached={files.length >= MOBILE_MAX_UPLOAD_FILES} onChange={onAddFiles} />
      </Box>
      <Box paddingTop={1}>
        <DocTypeSelector
          docType={docType}
          ocrBuilderConfigID={ocrBuilderConfigID}
          docTypeOptions={docTypeOptions}
          onOcrBuilderConfigIDChange={onOcrBuilderConfigIDChange}
          onDocTypeChange={onDocTypeChange}
        />
      </Box>
      <Box paddingTop={1}>
        <Selector
          label="保存グループ"
          description="保存するユーザーグループを選択"
          disabled={groupDisabled}
          value={group}
          options={groupSelectOptions}
          onChange={onGroupChange}
        />
      </Box>
      <Box paddingLeft={1}>
        <UploadItemList files={files} onDeleteFile={onDeleteFile} />
      </Box>
    </Box>
  )
}

export default UploadFields
